module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "hide"
  }, [_vm._v("Full Title")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-15"
  }, [_vm._v("Coast Guard Heroes")]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Basic-Paragraph para-style-override-15"
  }, [_vm._v("of New Orleans")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Basic-Paragraph para-style-override-9"
  }, [_c('span', {
    staticClass: "char-style-override-13"
  }, [_vm._v("Capt Robert Mueller, USCG ")]), _c('span', {
    staticClass: "char-style-override-14"
  }, [_vm._v("(ret)")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Basic-Paragraph para-style-override-16"
  }, [_vm._v("Foreword by Rear Adm. Joseph Castillo, "), _c('br'), _vm._v("U.S. Coast Guard (ret)")])]), _vm._v(" "), _c('div', {
    staticClass: "frame-2"
  }, [_c('img', {
    staticClass: "frame-3",
    attrs: {
      "alt": "PELOGO.TIF",
      "src": "Images/PELOGO_fmt.jpeg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-6"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-7"
  }, [_vm._v("Pelican Publishing Company")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-4"
  }, [_c('span', {
    staticClass: "char-style-override-5"
  }, [_vm._v("Gretna 2016")]), _c('span', {
    staticClass: "char-style-override-5"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1918b099","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/FullTitle.vue
// module id = 60
// module chunks = 0